<template>
    <div>
        <div class="form-group" v-if="prefijo==enumeraciones.etiquetasDeHTML.Select">
            <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
                <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un estatus del documento</option>
                <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los estatus de los documentos</option>
                <option v-for="tipoEstatusDeDocumento in TiposEstatusDocumentos" :value="tipoEstatusDeDocumento.TipoEstatusInventarioDocumentoId">{{tipoEstatusDeDocumento.Nombre}}</option>
            </select>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import axios from 'axios';
import api from '@/../static/js/api';
import comun from '@/../static/js/comun';

export default {
    data(){
        return {
            enumeraciones,
            comun,
            TiposEstatusDocumentos :[],
            idDelModelo: null
        }
    },
    props: {
        prefijo: Number,
        tipo: {
                Id: Number,
                Nombre: String 
            },
        idDelInput: String,
        valorDefinido: Number,
        parametros: Object
    },
    mounted() {
        if(this.valorDefinido == undefined || this.valorDefinido == null)
            {this.idDelModelo = this.tipo.Id;}
        else
            {this.idDelModelo = this.valorDefinido;}

        const parametros = {
            llave: this.idDelInput,
            valor: this.idDelModelo
        }
      
        this.$store.dispatch("A_ArchivoJudicial_Catalogo_Establecer004TipoEstatusVolumen", parametros);
    },
    methods: {
        cargaCatalogoTipoEstatusDocumento(){
            if(this.parametros == null || this.parametros == undefined)
                this.parametros = {}
            axios.post(api.conexion + api.ArchivoJudicial.TipoEstatusInventario, this.parametros)
            .then(respuesta=> {
                if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.TiposEstatusDocumentos = respuesta.data.TiposEstatusInventario;
              if(this.parametros.filtros !=undefined && this.parametros.filtros != null) {
                  this.TiposEstatusDocumentos = respuesta.data.TiposEstatusInventario.filter(cond=>this.parametros.filtros.some(tipo=>tipo.TiposEstatusInventario.TipoEstatusInventarioDocumentoId));
              }    
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })   
        },
        cambiarDatos(evento) {
            this.idDelModelo = evento.target.value;
            const parametros = {
                llave: this.idDelInput,
                valor: evento.target.value
                }
            this.$store.dispatch("A_ArchivoJudicial_Catalogo_Establecer004TipoEstatusVolumen", parametros);
            this.$emit("valorParaElPadre", evento);
        }
    },
    created() {
            this.cargaCatalogoTipoEstatusDocumento();
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/Catalogos/003TipoEstatusInventarioDocumento.vue